export default [
  {
    path: '/BccTelegramSetTeaching',
    name: 'BccTelegramSetTeaching',
    component: () => import(/* webpackPrefetch: true */'@/modules/gss/views/BccTelegramSetTeaching')
  }
];
